/* eslint "react/display-name": "warn" */
import { Heading } from '@realsoftworks/decor'

export default ({ ...props }) => (
  <Heading size={4} mb={2} {...props} />
)
